import { Box, styled } from '@mui/material';
import React from 'react';

import type { CompetitionWinner } from '@/lib/api/requests.ts';

export type CompetitionWinnersListProps = {
  winners: CompetitionWinner[];
};

export const CompetitionWinnersList: React.FC<CompetitionWinnersListProps> = ({ winners }) => {
  return (
    <>
      {winners.length > 0 ? (
        <ul className="mb-6 grid list-none grid-cols-[repeat(auto-fill,minmax(0,400px))] justify-center gap-x-8 gap-y-2 pl-2 typography-v1-body4 text-v1-neutral-100">
          {winners.map((w, i) => (
            <Box
              component="li"
              key={i}
              sx={{
                backgroundColor: '#F0F4FA',
                borderRadius: '4px',
                py: 2,
                px: { xs: 4, sm: 0 },
                position: 'relative',
              }}
            >
              <DarkCircle
                sx={{
                  transform: 'translateX(-49%)',
                  position: 'absolute',
                  left: 0,
                }}
              >
                {i + 1}
              </DarkCircle>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  rowGap: 0.5,
                }}
              >
                <Box sx={{ flex: 2, ml: { xs: 0, sm: 3 } }}>{w.name}</Box>
                <Box sx={{ flex: 1 }}>{w.age}</Box>
                <Box sx={{ flex: 1 }}>{w.city}</Box>
              </Box>
            </Box>
          ))}
        </ul>
      ) : (
        <p className="mb-4 text-center typography-v1-body3">
          Vinnerene er ikke kontaktet enda.
          <br />
          De vil publiseres når alle er kontaktet.
        </p>
      )}
    </>
  );
};

const DarkCircle = styled('span')(({ theme }) => ({
  borderRadius: '9999999px',
  aspectRatio: '1 / 1',
  display: 'inline-grid',
  lineHeight: 1,
  placeContent: 'center',
  backgroundColor: theme.palette.text.default,
  color: 'white',
  fontSize: '0.875rem',
  fontWeight: 700,
  height: '1.75em',
}));
